import {onIdle, ready} from './utils'
import './components/toggle-button';
import {initNewsletterForm} from './components/newsletter';

ready(() => {
  initNewsletterForm();

  if (document.querySelector('youtube-embed')) {
    onIdle(() => import('@components/youtube-embed'));
  }
})
